<template>
  <section>
    <div class="container is-grid">
      <div class="is-col-12-md">
        <h1>
          My Account<br class="show-br-mobile"/> Details </h1>
        <p class="header-paragraph">
          Here&rsquo;s your secret identity. Want to change something? Just hit the “Edit my details” button below. </p>
        <p class="header-paragraph errorMsg-text" v-if="pwReset">
          <strong>Your password has been reset!</strong>
        </p>
      </div>
      <div class="is-col-12-md">
        <div class="detail-row">
          <div class="left-column">
            <h2>Basic Information</h2>
            <table>
              <tr>
                <td>
                  <p><strong>First Name</strong></p>
                </td>
                <td>
                  <p>{{ firstName }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><strong>Last Name</strong></p>
                </td>
                <td>
                  <p>{{ lastName }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><strong>Email address</strong></p>
                </td>
                <td>
                  <p>{{ email }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><strong>Phone number</strong></p>
                </td>
                <td>
                  <p>{{ phoneNumber | phone }}</p>
                </td>
              </tr>
            </table>
          </div>
          <div class="right-column">
            <h2>Practice Information</h2>
            <table>
              <tr>
                <td>
                  <p><strong>Specialty</strong></p>
                </td>
                <td>
                  <p>{{ specialty }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>NPI Number</strong>
                  </p>
                </td>
                <td>
                  <p>{{ npiStateNumber }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><strong>Practice Name</strong></p>
                </td>
                <td>
                  <p>{{ practiceName }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><strong>Zip Code</strong></p>
                </td>
                <td>
                  <p>{{ zipCode }}</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="button-row">
        <p @click="$router.push({ name: 'ChangePassword' }).catch(() => {})" class="paragraph-link">
          Change Password </p>
        <button @click="$router.push({ name: 'EditAccountDetails' }).catch(() => {})">
          EDIT MY DETAILS <i class="fas fa-caret-right"></i>
        </button>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      firstName: this.$store.state.firstName,
      lastName: this.$store.state.lastName,
      email: this.$store.state.email,
      phoneNumber: this.$store.state.phoneNumber,
      specialty: this.$store.state.speciality,
      npiStateNumber: this.$store.state.npiStateNumber,
      practiceName: this.$store.state.practiceName,
      zipCode: this.$store.state.zipCode,
      errors: [],
      networkError: false,
      pwReset: false
    }
  },
  created () {
    this.getFormData()
  },
  mounted () {
    this.pwReset = this.$store.state.pwReset
    this.$store.state.pwReset = false
  },
  methods: {
    getFormData () {
      const _this = this
      _this.axios.get(_this.$apiUrl + 'v1/account').then(function (response) {
        if (response.data.errors.length === 0) {
          const d = response.data.user
          _this.firstName = d.first_name
          _this.lastName = d.last_name
          _this.email = d.email
          _this.phoneNumber = d.phone
          _this.specialty = d.specialty
          _this.npiStateNumber = d.npi_state_license_num
          _this.practiceName = d.practice_name
          _this.zipCode = d.practice_zip_code

          _this.$store.state.firstName = d.first_name
          _this.$store.state.lastName = d.last_name
          _this.$store.state.email = d.email

          localStorage.setItem('last_name', d.last_name)
        } else {
          console.error('AXIOS ERROR: CORS?')
        }
      }).catch(function (response) {
        if (response) {
          _this.output = response.errors
        } else {
          _this.networkError = true
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.container {
  display: flex;
  flex-flow: column wrap;
  // padding-left: 2%;
  @media screen and (max-width: 1000px) {
    padding-left: 20px;
  }

  h1 {
    font-size: 60px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 65px;
    @media screen and (max-width: 1000px) {
      margin-top: 1.1em;
      font-size: 45px;
      text-align: center;
    }

    @media screen and (max-width: ~"@{mq-xs-bp}") {
      width: 80%;
    }
  }

  h2 {
    @media screen and (max-width: 1000px) {
      font-size: 24px;
    }
  }

  .header-paragraph {
    @media screen and (max-width: 1000px) {
      width: 95%;
      // margin-left: auto;
      margin-right: auto;
      font-size: 1.8em;
    }

    @media screen and (max-width: ~"@{mq-xs-bp}") {
      width: 95%;
      margin-left: 0;
      padding-right: 30px;
    }
  }
}

.left-column {
  padding-right: 10%;
  @media screen and (max-width: 1000px) {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    padding-right: 0;
    margin-bottom: 40px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.right-column {
  @media screen and (max-width: 1000px) {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

table {
  width: 100%;

  tr {
    @media screen and (max-width: 1000px) {
      display: flex;
      flex-direction: column;
    }

    td {
      width: 400px;
      padding-top: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid @color-border-lt-gray;
      @media screen and (max-width: 1000px) {
        padding-top: 0;
        border-bottom: none;
      }

      p {
        padding-left: 0px;
        font-size: 14px;
        width: 150px;
        font-family: @open-sans-font;
        @media screen and (max-width: 1000px) {
          font-size: 18px;
        }
      }

      &:nth-child(1) {
        text-align: left;
        padding-right: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid @color-border-lt-gray;
        border-right: 1px solid @color-border-lt-gray;
        @media screen and (max-width: 1000px) {
          border-bottom: none;
          border-right: none;
        }
      }

      &:nth-child(2) {
        padding-right: 106px;

        p {
          padding-left: 30px;
          @media screen and (max-width: 1000px) {
            padding-left: 0;
          }
        }
      }
    }

    &:last-child {
      td {
        border-bottom: none;
      }
    }
  }
}

button {
  background-color: @color-orange;
  font-weight: 700;
  font-family: @open-sans-font;
  font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
  text-transform: uppercase;
  border: none;
  margin-top: 20px;
  padding: 1rem 1rem 1rem 1rem;
  cursor: pointer;
  @media screen and (max-width: 1000px) {
    width: 226px;
    font-size: 20px;
  }

  .fa-caret-right {
    margin-left: 7px;
  }
}

.detail-row {
  display: flex;
  flex: 1 50%;
  justify-content: center;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
}

.button-row {
  display: flex;
  flex-direction: column;
  width: 20%;

  @media screen and (max-width: 1000px) {
    width: 80%;
    margin-left: auto;
  }

  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-left: 0;
  }

  @media screen and (max-width: ~"@{mq-xs-bp}") {
    margin-left: unset;
  }

  a {
    font-size: 18px;
    margin-bottom: 20px;
  }
}
</style>
